import {UserDto} from "../../client/user/User";

export default class UserResolver {
    static isSystem(user: UserDto | undefined): boolean {
        if (user === undefined) {
            return false;
        }
        return user.login === "system";
    }
}